// export const api_url = "http://mark2.faheemacademy.online/api/v1/";
export const api_url = "http://sna.firststepacademy.online/api/v1/";